import React, { memo } from "react";
import { Spinner } from "@chakra-ui/react";

interface IProps {
  fileUrl?: string | null;
  name: string;
}

const FileOfficeViewer = ({ fileUrl, name }: IProps) => {
  if (!fileUrl) {
    return <Spinner />;
  }

  return (
    <iframe
      title={name}
      src={fileUrl}
      style={{
        width: "100%",
        height: "100%",
      }}
    />
  );
};

export default memo(FileOfficeViewer);
